import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=e66faa7c&scoped=true"
import script from "./DashboardHeader.vue?vue&type=script&lang=ts"
export * from "./DashboardHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66faa7c",
  null
  
)

export default component.exports